/** Only the verified invitation endpoint may disclose this minimal refusal detail. */
export function invitationForbiddenBody(
  body: Record<string, unknown> | undefined,
): Record<string, unknown> | undefined {
  if (!body) return undefined
  if (body.code === 'invitation_identity_unverified') return { code: body.code }
  if (
    body.code !== 'invitation_email_mismatch' ||
    typeof body.invitedEmail !== 'string' ||
    (body.authenticatedEmail !== null && typeof body.authenticatedEmail !== 'string')
  )
    return undefined
  return {
    code: body.code,
    invitedEmail: body.invitedEmail,
    authenticatedEmail: body.authenticatedEmail,
  }
}
